import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { HorizontalLine } from './HorizontalLine';
import Cookies from 'universal-cookie';

class IntegrationsPage extends React.Component {
    state = {
        website: null,
        loading: true,
        integrationCode: '',
        checkingCode: false,
        checkResult: null,
        integrations: {
            frontendCode: false,
            yandexMetrica: false,
            yandexDirect: false,
            googleAds: false
        },
        yandexMetrika: {
            connected: false,
            counters: [],
            selectedCounterId: null,
            loading: false,
            blockOnlyAdSessions: true
        },
        yandexSettings: {
            metrikaId: '105415078',
            metrikaName: 'zaryanovromain',
            directAccount: 'zaryanovromain',
            directType: 'Представительский аккаунт',
            protectedCampaigns: 1,
            blockOnlyAdSessions: true,
            triggerEvent: true
        },
        campaigns: [
            {
                id: '706286037',
                name: 'Единая перфоманс-кампания №3 от 14-01-2026',
                status: 'stopped'
            }
        ],
        selectedCampaigns: ['706286037'],
        websiteTariff: {
            name: 'Начальный',
            dailyCost: '100₽',
            monthlyVisits: 'до 10,000 визитов/мес',
            status: 'active',
            daysLeft: 7
        }
    }

    componentDidMount() {
        this.cookies = new Cookies();
        this.loadWebsiteData(this.props.websiteId);
        this.generateIntegrationCode();
        this.checkYandexMetrikaConnection();
        
        // Проверяем, если есть code в URL (редирект от Яндекса)
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code) {
            this.handleYandexCallback(code);
        }
    }

    loadWebsiteData = (websiteId) => {
        const mockData = {
            1: {
                id: 1,
                url: 'https://blog.flout.ru',
                name: 'Blog Platform',
                monthlyVisits: 8500
            },
            2: {
                id: 2,
                url: 'https://example-shop.ru',
                name: 'Example Shop', 
                monthlyVisits: 25000
            }
        };

        setTimeout(() => {
            this.setState({
                website: mockData[websiteId] || mockData[1],
                loading: false
            });
        }, 300);
    }

    async generateIntegrationCode() {
        const token = this.cookies.get('clickanti_token');
        const response = await fetch('https://api.clickanti.ru/api/clickanti/websites/'+this.props.websiteId+'/tracking-code/', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Ошибка загрузки: ${response.status}`);
        }

        const data = await response.json();
        const code = data.tracking_code;

        this.setState({ integrationCode: code });
    }

    checkTrackingCode = async () => {
        this.setState({ checkingCode: true, checkResult: null });
        
        try {
            const token = this.cookies.get('clickanti_token');
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/websites/${this.props.websiteId}/check-tracking-code/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Ошибка проверки: ${response.status}`);
            }

            const data = await response.json();
            
            this.setState({ 
                checkResult: data,
                checkingCode: false,
                integrations: {
                    ...this.state.integrations,
                    frontendCode: data.check_result?.code_found || false
                }
            });
        } catch (error) {
            console.error('Ошибка при проверке кода:', error);
            this.setState({ 
                checkingCode: false,
                checkResult: {
                    success: false,
                    error: error.message
                }
            });
        }
    }

    toggleIntegration = (integrationType) => {
        this.setState(prevState => ({
            integrations: {
                ...prevState.integrations,
                [integrationType]: !prevState.integrations[integrationType]
            }
        }));
    }

    toggleSetting = (settingName) => {
        this.setState(prevState => ({
            yandexSettings: {
                ...prevState.yandexSettings,
                [settingName]: !prevState.yandexSettings[settingName]
            }
        }));
    }

    toggleCampaignSelection = (campaignId) => {
        const { selectedCampaigns } = this.state;
        const newSelection = selectedCampaigns.includes(campaignId)
            ? selectedCampaigns.filter(id => id !== campaignId)
            : [...selectedCampaigns, campaignId];

        this.setState({ selectedCampaigns: newSelection });
    }

    selectAllCampaigns = () => {
        const allCampaignIds = this.state.campaigns.map(c => c.id);
        const allSelected = this.state.selectedCampaigns.length === this.state.campaigns.length;
        
        this.setState({
            selectedCampaigns: allSelected ? [] : allCampaignIds
        });
    }

    copyToClipboard = () => {
        navigator.clipboard.writeText(this.state.integrationCode).then(() => {
            console.log('Код скопирован в буфер обмена!');
        });
    }

    goBack = () => {
        window.history.back();
    }

    // Яндекс.Метрика методы
    checkYandexMetrikaConnection = async () => {
        try {
            const token = this.cookies.get('clickanti_token');
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/websites/${this.props.websiteId}/yandex-counters/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    yandexMetrika: {
                        connected: true,
                        counters: data.counters,
                        selectedCounterId: data.selected_counter_id,
                        loading: false,
                        blockOnlyAdSessions: data.integration.block_only_ad_sessions
                    },
                    integrations: {
                        ...this.state.integrations,
                        yandexMetrica: true
                    }
                });
            } else if (response.status === 404) {
                // Метрика не подключена
                this.setState({
                    yandexMetrika: {
                        ...this.state.yandexMetrika,
                        connected: false,
                        loading: false
                    }
                });
            }
        } catch (error) {
            console.error('Ошибка проверки Яндекс.Метрики:', error);
        }
    }


    connectYandexMetrika = () => {

        const cookies = new Cookies();
        cookies.set('metrika_connecting_to_website', 
                this.props.websiteId,
                 {path : '/'});


        const clientId = '0938f4fde8ae4969aa8a2ce984dbcac1';
        const redirectUri = ''
        const authUrl = `https://oauth.yandex.ru/authorize?response_type=code&client_id=${clientId}`;
        window.location.href = authUrl;
    }

    selectYandexCounter = async (counterId) => {
        
            const token = this.cookies.get('clickanti_token');
            fetch(`https://api.clickanti.ru/api/clickanti/websites/${this.props.websiteId}/select-counter/`, {
    method: 'POST',
    headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({ counter_id: counterId })
})
.then(response => {
    if (response.ok) {
        // Перезагружаем страницу, чтобы все куки и сессии перечитались с сервера
        window.location.reload(); 
    } else {
        return response.json().then(err => { alert(`Ошибка: ${err.error}`) });
    }
})
.catch(err => console.error(err));


        
    }

    toggleYandexSetting = async (settingName) => {
        const newValue = !this.state.yandexMetrika[settingName];
        
        try {
            const token = this.cookies.get('clickanti_token');
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/websites/${this.props.websiteId}/yandex-settings/`, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ [settingName]: newValue })
            });

            if (response.ok) {
                window.location.reload()
                

            }
        } catch (error) {
            console.error('Ошибка обновления настроек:', error);
        }
    }

    disconnectYandexMetrika = async () => {
        

        try {
            const token = this.cookies.get('clickanti_token');
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/websites/${this.props.websiteId}/disconnect-yandex/`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                this.setState({
                    yandexMetrika: {
                        connected: false,
                        counters: [],
                        selectedCounterId: null,
                        loading: false,
                        blockOnlyAdSessions: true
                    },
                    integrations: {
                        ...this.state.integrations,
                        yandexMetrica: false
                    }
                });
                alert('Яндекс.Метрика отключена');
            }
        } catch (error) {
            console.error('Ошибка отключения:', error);
        }
    }

    renderCheckResult = () => {
        const { checkResult } = this.state;
        
        if (!checkResult) return null;

        const isSuccess = checkResult.success && checkResult.check_result?.code_found;
        
        return (
            <div style={{
                marginTop: '1.5em',
                padding: '1.5em',
                background: isSuccess ? '#E8F5E9' : '#FFEBEE',
                borderRadius: '0.5em',
                borderLeft: `4px solid ${isSuccess ? '#2E7D32' : '#D32F2F'}`
            }}>
                <div style={{
                    fontWeight: '600',
                    color: isSuccess ? '#2E7D32' : '#D32F2F',
                    marginBottom: '1em',
                    fontSize: '1.1em'
                }}>
                    {isSuccess ? '✓ Проверка выполнена успешно' : '✗ Код не найден'}
                </div>
                
                {checkResult.recommendations && checkResult.recommendations.length > 0 && (
                    <div style={{color: '#666', lineHeight: '1.6'}}>
                        {checkResult.recommendations.map((rec, idx) => (
                            <div key={idx}>{rec}</div>
                        ))}
                    </div>
                )}
                
                {checkResult.check_result && (
                    <div style={{marginTop: '1em', fontSize: '0.95em', color: '#666'}}>
                        <div>Статус: {checkResult.check_result.status_code}</div>
                        {checkResult.check_result.details && (
                            <>
                                <div>Найдено скриптов: {checkResult.check_result.details.scripts_found}</div>
                                <div>analyze.js: {checkResult.check_result.details.analyze_js_found ? '✓' : '✗'}</div>
                                <div>ClickAnti.init: {checkResult.check_result.details.clickanti_init_found ? '✓' : '✗'}</div>
                                <div>Корректный API ключ: {checkResult.check_result.details.correct_api_key ? '✓' : '✗'}</div>
                            </>
                        )}
                    </div>
                )}
                
                {checkResult.check_result?.error && (
                    <div style={{marginTop: '1em', color: '#D32F2F'}}>
                        Ошибка: {checkResult.check_result.error}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { website, loading, integrationCode, integrations, yandexSettings, campaigns, selectedCampaigns, websiteTariff, checkingCode, yandexMetrika } = this.state;

        if (loading) {
            return (
                <div className='createPage' style={{textAlign: 'center', padding: '4em'}}>
                    <div className='notCreatedText'>Загрузка...</div>
                </div>
            );
        }

        return (
            <div className='createPage'>
                {/* Кнопка назад */}
                <div className='createWidgetMainBlock_back' onClick={this.goBack} style={{cursor: 'pointer', marginBottom: '2em'}}>
                    ← Назад к списку сайтов
                </div>

                {/* Заголовок и информация о тарифе в одной строке */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '1em'
                }}>
                    <div>
                        <h1 style={{margin: 0}}>Интеграции для {website.url}</h1>
                    </div>
                </div>

                <HorizontalLine />
                
                {/* 1. Блок с кодом интеграции */}
                <div className='editBlock' style={{marginTop: '2.5em'}}>
                    <div className='editBlock_name' style={{marginBottom: '2em'}}>
                        <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                            1. Код для вставки на сайт
                        </h2>
                        <div style={{
                            display: 'inline-block',
                            marginLeft: '2em',
                            padding: '0.3em 1em',
                            borderRadius: '1em',
                            background: integrations.frontendCode ? '#E8F5E9' : '#FFF3E0',
                            color: integrations.frontendCode ? '#2E7D32' : '#F57C00',
                            fontSize: '0.9em',
                            fontWeight: '500'
                        }}>
                            {integrations.frontendCode ? '✓ Выполнено' : 'Требуется выполнить'}
                        </div>
                    </div>
                    
                    <div className='inputsBlock_block' style={{width: '100%'}}>
                        <div className='inputsBlock_block_label' style={{color: '#9197B3', fontSize: '1.2em', marginBottom: '1em'}}>
                            Скопируйте этот код и разместите в теге &lt;head&gt; вашего сайта:
                        </div>
                        <div style={{
                            position: 'relative',
                            background: '#F3F3F3',
                            borderRadius: '0.5em',
                            padding: '1.5em',
                            fontFamily: "'Courier New', monospace",
                            fontSize: '1.2em',
                            lineHeight: '1.6',
                            width: '100%',
                            boxSizing: 'border-box'
                        }}>
                            <pre style={{
                                margin: 0,
                                overflowX: 'auto',
                                color: '#333',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word'
                            }}>{integrationCode}</pre>
                            <button 
                                onClick={this.copyToClipboard}
                                className='btn1'
                                style={{
                                    position: 'absolute',
                                    top: '1em',
                                    right: '1em',
                                    fontSize: '1em',
                                    padding: '0.6em 1.2em'
                                }}
                            >
                                Копировать
                            </button>
                        </div>
                        
                        <div style={{marginTop: '1.5em', textAlign: 'right'}}>
                            <a 
                                href='#'
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.checkTrackingCode();
                                }}
                                className='btn1'
                                style={{
                                    background: checkingCode ? '#9197B3' : '#0767F4',
                                    display: 'inline-block',
                                    textDecoration: 'none',
                                    padding: '0.8em 1.8em',
                                    fontSize: '1em',
                                    opacity: checkingCode ? 0.7 : 1,
                                    cursor: checkingCode ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {checkingCode ? 'Проверка...' : 'Проверить установку на сайт'}
                            </a>
                        </div>

                        {this.renderCheckResult()}
                    </div>
                </div>

                {/* 2. Блок Яндекс интеграций */}
                <div className='editBlock' style={{marginTop: '2.5em'}}>
                    <div className='editBlock_name'>
                        <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                            2. Настройка Яндекс.Метрика защиты
                        </h2>
                        <div style={{
                            display: 'inline-block',
                            marginLeft: '2em',
                            padding: '0.3em 1em',
                            borderRadius: '1em',
                            background: yandexMetrika.connected ? '#E8F5E9' : '#FFF3E0',
                            color: yandexMetrika.connected ? '#2E7D32' : '#F57C00',
                            fontSize: '0.9em',
                            fontWeight: '500'
                        }}>
                            {yandexMetrika.connected ? '✓ Подключено' : 'Не подключено'}
                        </div>
                    </div>
                    
                    <div style={{marginTop: '2em'}}>
                        {!yandexMetrika.connected ? (
                            // Форма подключения
                            <div>
                                <div style={{
                                    padding: '2em',
                                    background: '#FAFBFF',
                                    borderRadius: '0.8em',
                                    textAlign: 'center'
                                }}>
                                    <div style={{fontSize: '1.2em', marginBottom: '1em', color: '#252733'}}>
                                        Подключите Яндекс.Метрику для защиты от кликфрода
                                    </div>
                                    <button 
                                        onClick={this.connectYandexMetrika}
                                        className='btn1'
                                        style={{
                                            background: '#FF0000',
                                            padding: '1em 2em',
                                            fontSize: '1.1em'
                                        }}
                                    >
                                        Подключить Яндекс.Метрику
                                    </button>
                                </div>
                            </div>
                        ) : (
                            // Подключено - показываем счетчики
                            <div>
                                {/* Информационные блоки
                                <div style={{
                                    padding: '1.5em',
                                    background: '#FFF3E0',
                                    borderRadius: '0.5em',
                                    borderLeft: '4px solid #ff9900',
                                    marginBottom: '1.5em'
                                }}>
                                    <div style={{fontWeight: '600', color: '#F57C00', marginBottom: '0.5em'}}>
                                        Для корректной работы нашего алгоритма
                                    </div>
                                    <div style={{color: '#666', lineHeight: '1.6'}}>
                                        Не забудьте настроить utm-метки в ваших рекламных кампаниях. Для вашего удобства 
                                        мы сделали генератор utm-меток, он доступен по ссылке{' '}
                                        <a href="https://clickfraud.ru/utm/" target="_blank" rel="noopener noreferrer" style={{color: '#0767F4'}}>
                                            https://clickfraud.ru/utm/
                                        </a>.{' '}
                                        <a href="#" style={{color: '#0767F4'}}>Подробнее</a>
                                    </div>
                                </div>
                                 */}
                                <div style={{
                                    padding: '1.5em',
                                    background: '#e8f4f8',
                                    borderRadius: '0.5em',
                                    borderLeft: '4px solid #0767F4',
                                    marginBottom: '2em'
                                }}>
                                    <div style={{fontWeight: '600', color: '#0767F4', marginBottom: '0.5em'}}>
                                        Чтобы алгоритм блокировки ботов работал
                                    </div>
                                    <div style={{color: '#666', lineHeight: '1.6'}}>
                                        
                                        <a target="_blank" href='https://telegra.ph/Kak-nastroit-YAndeksmetriku-i-YAndeksdirekt-dlya-raboty-s-ClickAnti-01-25' style={{color: '#0767F4'}}>Прочитайте инструкцию</a>
                                    </div>
                                </div>

                                {/* Список счетчиков */}
                                <div style={{marginBottom: '2em'}}>
                                    <h3 style={{color: '#252733', marginBottom: '1em'}}>Выберите счетчик Яндекс.Метрики:</h3>
                                    
                                    {yandexMetrika.counters.length === 0 ? (
                                        <div style={{padding: '2em', textAlign: 'center', color: '#9197B3'}}>
                                            У вас нет доступных счетчиков Яндекс.Метрики
                                        </div>
                                    ) : (
                                        <div>
                                            {yandexMetrika.counters.map(counter => (
                                                <div 
                                                    key={counter.id}
                                                    style={{
                                                        padding: '1.5em',
                                                        background: yandexMetrika.selectedCounterId === String(counter.id) ? '#E8F5E9' : '#FAFBFF',
                                                        borderRadius: '0.8em',
                                                        marginBottom: '1em',
                                                        border: yandexMetrika.selectedCounterId === String(counter.id) ? '2px solid #2E7D32' : '1px solid #E5E5E5',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => this.selectYandexCounter(counter.id)}
                                                >
                                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                                        <div>
                                                            <div style={{fontWeight: '600', color: '#252733', fontSize: '1.1em'}}>
                                                                {counter.name || counter.site}
                                                            </div>
                                                            <div style={{color: '#9197B3', marginTop: '0.3em'}}>
                                                                ID: {counter.id} | {counter.site}
                                                            </div>
                                                            {counter.status && (
                                                                <div style={{marginTop: '0.5em', fontSize: '0.9em'}}>
                                                                    <span style={{
                                                                        padding: '0.3em 0.8em',
                                                                        borderRadius: '1em',
                                                                        background: counter.status === 'CS_OK' ? '#E8F5E9' : '#FFF3E0',
                                                                        color: counter.status === 'CS_OK' ? '#2E7D32' : '#F57C00'
                                                                    }}>
                                                                        {counter.status === 'CS_OK' ? 'Установлен' : 'Не установлен'}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {yandexMetrika.selectedCounterId === String(counter.id) && (
                                                            <div style={{color: '#2E7D32', fontSize: '1.5em'}}>
                                                                ✓
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Настройки 
                                {yandexMetrika.selectedCounterId && (
                                    <div style={{
                                        padding: '1.5em',
                                        background: '#FAFBFF',
                                        borderRadius: '0.8em',
                                        marginBottom: '1.5em'
                                    }}>
                                        <h3 style={{color: '#252733', marginBottom: '1em'}}>Настройки защиты</h3>
                                        <label style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5em',
                                            cursor: 'pointer',
                                            color: '#666'
                                        }}>
                                            <input
                                                type="checkbox"
                                                checked={yandexMetrika.blockOnlyAdSessions}
                                                onChange={() => this.toggleYandexSetting('blockOnlyAdSessions')}
                                                style={{width: '1.2em', height: '1.2em'}}
                                            />
                                            Блокировать только рекламные сессии
                                        </label>
                                    </div>
                                )}*/}

                                {/* Кнопка отключения */}
                                <div style={{textAlign: 'right'}}>
                                    <button
                                        onClick={this.disconnectYandexMetrika}
                                        style={{
                                            background: '#fff',
                                            border: '1px solid #D32F2F',
                                            color: '#D32F2F',
                                            padding: '0.8em 1.5em',
                                            borderRadius: '0.5em',
                                            cursor: 'pointer',
                                            fontSize: '1em'
                                        }}
                                    >
                                        Отключить Яндекс.Метрику
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* 3. Блок Google Ads */}
                <div className='editBlock' style={{marginTop: '2.5em'}}>
                    <div className='editBlock_name'>
                        <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                            3. Google Реклама
                        </h2>
                    </div>
                    
                    <div style={{marginTop: '2em'}}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <div style={{color: '#252733', fontWeight: '600', fontSize: '1.3em'}}>
                                    Google Ads
                                </div>
                                <div style={{color: '#9197B3', fontSize: '1.1em', marginTop: '0.3em'}}>
                                    Контекстная реклама в поиске Google
                                </div>
                            </div>
                            <a 
                                href='#'
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                                className='btn1'
                                style={{
                                    background: integrations.googleAds ? '#9197B3' : '#4285F4',
                                    display: 'inline-block',
                                    textDecoration: 'none',
                                    padding: '0.8em 1.8em',
                                    fontSize: '1em',
                                    minWidth: '10em',
                                    textAlign: 'center'
                                }}
                            >
                                {integrations.googleAds ? '✓ Подключено' : 'Подключить'}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Обертка для использования useParams
const IntegrationsPageWrapper = () => {
    let { id } = useParams();
    return <IntegrationsPage websiteId={id} />;
};

export default IntegrationsPageWrapper;